import React from "react";
import { ChevronLeft, ChevronRight, Close } from "@mui/icons-material";

export function MetricCard({ label, value, hint, icon }) {
  return (
    <div className="metric-card">
      <div className="metric-card__top">
        <span>{label}</span>
        {icon}
      </div>
      <strong>{value}</strong>
      {hint && <span>{hint}</span>}
    </div>
  );
}

export function StatusPill({ value }) {
  const normalized = String(value || "").toUpperCase();
  const className =
    normalized.includes("SOLDE") || normalized.includes("CLOTURE") || normalized.includes("ACTIVE") || normalized.includes("PAID")
      ? "is-good"
      : normalized.includes("RETARD") || normalized.includes("OPEN") || normalized.includes("PERDU")
        ? "is-danger"
        : "is-warning";

  return <span className={`status-pill ${className}`}>{value || "N/A"}</span>;
}

export function EmptyState({ label = "Aucune donnee disponible." }) {
  return <div className="empty-state">{label}</div>;
}

export function LoadingOverlay({ show, label = "Traitement en cours..." }) {
  if (!show) return null;

  return (
    <div className="loading-overlay" role="status" aria-live="polite">
      <span />
      <strong>{label}</strong>
    </div>
  );
}

export function Modal({ title, children, onClose, footer }) {
  return (
    <div className="modal-backdrop" role="presentation">
      <div className="modal-dialog" role="dialog" aria-modal="true" aria-label={title}>
        <div className="modal-head">
          <h2>{title}</h2>
          <button className="icon-action" type="button" onClick={onClose} aria-label="Fermer">
            <Close />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export function Pagination({ page, totalPages, totalItems, from, to, onPageChange }) {
  if (totalItems <= 0) return null;

  return (
    <div className="pagination-bar">
      <span>{from}-{to} sur {totalItems}</span>
      <div className="pagination-actions">
        <button className="icon-action" type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1} aria-label="Page precedente">
          <ChevronLeft />
        </button>
        <strong>{page} / {totalPages}</strong>
        <button className="icon-action" type="button" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages} aria-label="Page suivante">
          <ChevronRight />
        </button>
      </div>
    </div>
  );
}
